import {
  Chatbot,
  Marketplaces,
  Shipments,
  Suggestions,
  Tracking,
  Warranty
} from './features-layouts'
import { Feature } from './feature'

const upcomingFeatures = [
  { component: Chatbot, title: 'Chatbot' },
  { component: Marketplaces, title: 'Marketplaces' },
  { component: Suggestions, title: 'Suggestions' },
  { component: Warranty, title: 'Warranty' },
  { component: Shipments, title: 'Shipments' },
  { component: Tracking, title: 'Tracking' }
]

export const UpcomingFeatures = () => {
  return (
    <div className="grid w-full grid-cols-3 gap-3">
      {upcomingFeatures.map((feature, index) => {
        return (
          <Feature
            key={index}
            title={feature.title}
            layout={<feature.component />}
          />
        )
      })}
    </div>
  )
}
export default UpcomingFeatures
